import { NgModule } from '@angular/core';
import { NotificationsComponent } from 'app/components/notification/notifications.component';
import { NotificationComponent } from 'app/components/notification/notification.component';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { I360TranslateModule } from 'app/utils/translate/translate.module';


@NgModule({
    imports: [
        CommonModule,
        MatButtonModule,
        MatIconModule,
        I360TranslateModule,
    ],
    declarations: [
        NotificationsComponent,
        NotificationComponent,
    ],
    exports: [
        NotificationsComponent,
    ],
})
export class I360NotificationsModule {}
